import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ApplicantsService } from '../../../services/http/applicants/applicants.service';
import { ApplicantIndividual, ApplicantIndividualContact, ApplicantIndividualIdentification, ApplicantOrganisationIdentification, ApplicantRequest, Relationship } from '../../../services/http/applicants/applicants.interface';
import { CodeName, RequestDate } from '../../../services/http/common.http.interface';
import { FormsModule } from '@angular/forms';
import { Country } from '../../../services/http/countries/countries.interface';
import { CountriesService } from '../../../services/http/countries/countries.service';
import { MunicipalityProvinceData } from '../../../services/http/municipalities/municipalities.interface';
import { MunicipalitiesService } from '../../../services/http/municipalities/municipalities.service';
import { Province } from '../../../services/http/provinces/provinces.interface';
import { ProvincesService } from '../../../services/http/provinces/provinces.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { AlertService } from '../../../services/alert/alert.service';
import { AlertType } from '../../../services/alert/alert.interface';
import { Attachment } from '../../../services/http/attachments/attachments.interface';
import { AuthService } from '../../../services/auth/auth.service';
import { ExceptionsService } from '../../../services/http/exceptions/exceptions.service';
@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  relationships: Relationship[] = [];
  countries: Country[] = [];
  provinces: Province[] = [];
  municipalities: MunicipalityProvinceData[] = [];
  applicant: ApplicantRequest = {
    identifier: "",
    applicantType: "",
    individual: undefined,
    company: undefined,
    represented: undefined,
    password: "3R9i+mCo8>e8", // Todo: quitar del registro no se usa pass
    comments: "",
    attachments: [] as Attachment[],
    flags: {
      email: false,
      sms: false,
      personal: false,
      privacity: false,
      protection: false,
      veracity: false,
      vehicleDocumentation: false
    }
  }
  streetTypes: CodeName[] = [];
  password: string = "";
  password2: string = "";
  confirmEmail: string = "";
  isValid = false;

  sendEmail = false;
  sendSMS = false;

  userLogued: any;

  loaded = false;

  constructor(
    private applicantsService: ApplicantsService,
    private countriesService: CountriesService,
    private municipalitiesService: MunicipalitiesService,
    private provincesService: ProvincesService,
    private router: Router,
    private readonly loaderService: LoaderService,
    private readonly alertService: AlertService,
    private readonly authService: AuthService,
    private exceptionsService: ExceptionsService
  ) {
    this.applicantsService.getRelationships().subscribe(
      data => {
        this.relationships = data.relationships;
      }
    );
    this.countriesService.getCountries().subscribe(
      data => {
        this.countries = data.countries;
      }
    );
    this.provincesService.getProvinces().subscribe(
      data => {
        this.provinces = data.provinces;
      }
    );
    this.exceptionsService.getSteetTypes().subscribe(
      data => {
        this.streetTypes = data.streets;
      }
    );
  }

  async ngOnInit() {
    try {
      const userLogued = await this.authService.getUser();
      this.userLogued = userLogued;
      if (userLogued) {
        this.applicantsService.getCurrentApplicant().subscribe({
          next: applicant => {
            this.router.navigate(['/vehicles']);
          },
          error: error => {
            this.loaded = true;
            this.loadUserLogued();
          }
        });
      } else {
        this.authService.logoutUser();
        const url = await this.authService.initLoginPublic();
        window.location.href = url;
      }
    } catch (error) {
      this.authService.logoutUser();
      const url = await this.authService.initLoginPublic();
      window.location.href = url;
    }
  }

  async loadUserLogued() {
    // set default values
    this.applicant.applicantType = 'Individual';
    this.applicant.individual = {
      applicantIdentification: {
        name: this.userLogued.aoc.user.name,
        firstSurname: this.userLogued.aoc.user.surnames.split(' ')[0],
        secondSurname: this.userLogued.aoc.user.surnames.split(' ')[1],
        dateOfBirth: {
          date: ""
        } as RequestDate,
        documentType: "NIF",
        documentIdentification: this.userLogued.aoc.user.identifier
      } as ApplicantIndividualIdentification,
      applicantContact: {
        countryCode: 0,
        phoneNumber: "",
        province: "",
        municipality: "",
        streetName: "",
        streetNumber: "",
        floor: "",
        door: "",
        stairCase: "",
        block: "",
        postalCode: "",
        email: ""
      } as ApplicantIndividualContact
    } as ApplicantIndividual;
  }

  checkValid() {
    this.isValid = false;
    switch (this.applicant?.applicantType) {
      case 'Individual':
        this.applicant.identifier = this.applicant.individual!.applicantIdentification.documentIdentification;
        this.isValid =
          this.applicant.individual?.applicantIdentification.name !== "" &&
          this.applicant.individual?.applicantIdentification.firstSurname !== "" &&
          this.applicant.individual?.applicantIdentification.dateOfBirth.date !== "" &&
          this.applicant.individual?.applicantIdentification.documentType !== "" &&
          this.applicant.individual?.applicantIdentification.documentIdentification !== "" &&
          this.applicant.individual?.applicantContact.email !== "" &&
          this.confirmEmail !== "" &&
          this.password !== "" &&
          this.password2 !== "" &&
          this.password === this.password2 &&
          this.applicant.flags!.privacity;
        break;
      case 'Company':
        this.applicant.identifier = this.applicant.company!.applicantIdentification.documentIdentification;
        this.isValid =
          this.applicant.company?.applicantIdentification.name !== "" &&
          this.applicant.company?.applicantIdentification.firstSurname !== "" &&
          this.applicant.company?.applicantIdentification.dateOfBirth.date !== "" &&
          this.applicant.company?.applicantIdentification.documentType !== "" &&
          this.applicant.company?.applicantIdentification.documentIdentification !== "" &&
          this.applicant.company?.applicantContact.email !== "" &&
          this.confirmEmail !== "" &&

          this.applicant.company?.identification.documentIdentification !== "" &&
          this.applicant.company?.identification.documentType !== "" &&
          this.applicant.company?.identification.registeredName !== "" &&

          this.applicant.company?.relationship !== "" &&
          this.applicant.company?.representativeIdentification.name !== "" &&
          this.applicant.company?.representativeIdentification.firstSurname !== "" &&
          this.applicant.company?.representativeIdentification.dateOfBirth.date !== "" &&
          this.applicant.company?.representativeIdentification.documentType !== "" &&
          this.applicant.company?.representativeIdentification.documentIdentification !== "" &&

          this.password !== "" &&
          this.password2 !== "" &&
          this.password === this.password2 &&

          this.applicant.flags!.privacity;
        break;
      case 'Represented':
        this.applicant.identifier = this.applicant.represented!.applicantIdentification.documentIdentification;
        this.isValid =
          this.applicant.represented?.applicantIdentification.name !== "" &&
          this.applicant.represented?.applicantIdentification.firstSurname !== "" &&
          this.applicant.represented?.applicantIdentification.dateOfBirth.date !== "" &&
          this.applicant.represented?.applicantIdentification.documentType !== "" &&
          this.applicant.represented?.applicantIdentification.documentIdentification !== "" &&
          this.applicant.represented?.applicantContact.email !== "" &&
          this.confirmEmail !== "" &&

          this.applicant.represented?.relationship !== "" &&
          this.applicant.represented?.representativeIdentification.name !== "" &&
          this.applicant.represented?.representativeIdentification.firstSurname !== "" &&
          this.applicant.represented?.representativeIdentification.dateOfBirth.date !== "" &&
          this.applicant.represented?.representativeIdentification.documentType !== "" &&
          this.applicant.represented?.representativeIdentification.documentIdentification !== "" &&

          this.password !== "" &&
          this.password2 !== "" &&
          this.password === this.password2 &&

          this.applicant.flags!.privacity;
        break;
    }
  }

  clearOtherForms() {
    this.isValid = false;
    switch (this.applicant?.applicantType) {
      case 'Individual':
        this.applicant.individual = {
          applicantIdentification: {
            name: this.userLogued?.aoc.user.name,
            firstSurname: this.userLogued?.aoc.user.surnames.split(' ')[0],
            secondSurname: this.userLogued?.aoc.user.surnames.split(' ')[1],
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "NIF",
            documentIdentification: this.userLogued?.aoc.user.identifier
          } as ApplicantIndividualIdentification,
          applicantContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: ""
          } as ApplicantIndividualContact
        } as ApplicantIndividual;
        this.applicant.company = undefined;
        this.applicant.represented = undefined;
        break;
      case 'Company':
        this.applicant.individual = undefined;
        this.applicant.company = {
          applicantIdentification: {
            name: this.userLogued?.aoc.user.name,
            firstSurname: this.userLogued?.aoc.user.surnames.split(' ')[0],
            secondSurname: this.userLogued?.aoc.user.surnames.split(' ')[1],
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "NIF",
            documentIdentification: this.userLogued?.aoc.user.identifier
          } as ApplicantIndividualIdentification,
          applicantContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: ""
          } as ApplicantIndividualContact,
          identification: {
            documentIdentification: "",
            documentType: "",
            registeredName: ""
          } as ApplicantOrganisationIdentification,
          relationship: "",
          representativeContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: "",
          } as ApplicantIndividualContact,
          representativeIdentification: {
            name: "",
            firstSurname: "",
            secondSurname: "",
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "",
            documentIdentification: ""
          } as ApplicantIndividualIdentification
        };
        this.applicant.represented = undefined;
        break;
      case 'Represented':
        this.applicant.individual = undefined;
        this.applicant.company = undefined;
        this.applicant.represented = {
          applicantContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: ""
          } as ApplicantIndividualContact,
          applicantIdentification: {
            name: this.userLogued?.aoc.user.name,
            firstSurname: this.userLogued?.aoc.user.surnames.split(' ')[0],
            secondSurname: this.userLogued?.aoc.user.surnames.split(' ')[1],
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "NIF",
            documentIdentification: this.userLogued?.aoc.user.identifier
          } as ApplicantIndividualIdentification,
          relationship: "",
          representativeContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: ""
          } as ApplicantIndividualContact,
          representativeIdentification: {
            name: "",
            firstSurname: "",
            secondSurname: "",
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "",
            documentIdentification: ""
          } as ApplicantIndividualIdentification
        };
        break;
    }
  }

  // Track which fields have been touched
  touchedFields: { [key: string]: boolean } = {};
  formSubmitted = false;

  // Method to check if a field is valid
  isFieldValid(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }

  // Mark a field as touched when user interacts with it
  markAsTouched(fieldName: string): void {
    this.touchedFields[fieldName] = true;
  }

  // Check if field should show error
  shouldShowError(fieldName: string, value: any): boolean {
    return (this.touchedFields[fieldName] || this.formSubmitted) && !this.isFieldValid(value);
  }

  createApplicant() {
    this.formSubmitted = true; // Mark form as submitted to show all errors
    
    if (!this.isValid) {
      // Find all required fields that are empty
      const emptyFields: string[] = [];
      
      switch (this.applicant?.applicantType) {
        case 'Individual':
          // Check individual fields and add to emptyFields if needed
          // ... existing validation logic ...
          break;
        case 'Company':
          // Check company fields and add to emptyFields if needed
          // ... existing validation logic ...
          break;
        case 'Represented':
          // Check represented fields and add to emptyFields if needed
          // ... existing validation logic ...
          break;
      }
      
      this.alertService.setAlert({
        message: $localize`:@@Register.Required:Rellene todos los campos requeridos`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 5000
      });
      return;
    }
    
    this.loaderService.show();
    let validEmail = false;
    let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    switch (this.applicant?.applicantType) {
      case 'Individual':
        if (this.applicant.individual && this.applicant.individual.applicantContact.email.match(emailRegex))
          validEmail = this.confirmEmail === this.applicant.individual.applicantContact.email;
        break;
      case 'Company':
        if (this.applicant.company && this.applicant.company.applicantContact.email.match(emailRegex))
          validEmail = this.confirmEmail === this.applicant.company.applicantContact.email;
        break;
      case 'Represented':
        if (this.applicant.represented && this.applicant.represented.applicantContact.email.match(emailRegex))
          validEmail = this.confirmEmail === this.applicant.represented.applicantContact.email;
        break;
    }
    // if (!this.sendEmail && !this.sendSMS) {
    //   this.alertService.setAlert({
    //     message: $localize`:@@Profile.NoCommunication:Debe seleccionar al menos un medio de comunicación.`,
    //     type: AlertType.Error,
    //     dismissible: true,
    //     dismissOnTimeout: 2000
    //   });
    //   return;
    // }
    if (validEmail) {
      this.applicant.flags!.email = this.sendEmail;
      this.applicant.flags!.sms = this.sendSMS;
      this.applicant.password = this.password;
      this.applicantsService.createApplicant(this.applicant).subscribe(
        data => {
          this.loaderService.hide();
          sessionStorage.setItem('applicant', 'true');
          this.alertService.setAlert({
            message: $localize`:@@Register.Created:Usuario creado correctamente`,
            type: AlertType.Success,
            dismissible: true,
            dismissOnTimeout: 2000
          });
          this.authService.getAppliant();
          this.router.navigate(['/vehicles']);
        }
      );
    } else {
      this.loaderService.hide();
      this.alertService.setAlert({
        message: $localize`:@@Register.EmailError:Los emails son incorrectos`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
    }
  }

  loadMunicipalities() {
    let province = '';
    switch (this.applicant?.applicantType) {
      case 'Individual':
        province = this.applicant.individual!.applicantContact.province;
        break;
      case 'Company':
        province = this.applicant.company!.applicantContact.province;
        break;
      case 'Represented':
        province = this.applicant.represented!.applicantContact.province;
        break;
    }
    this.municipalitiesService.getMunicipalitiesByProvince(province).subscribe(
      data => {
        this.municipalities = data.municipalities;
      }
    );
  }

  register() {
    this.applicantsService.createApplicant(this.applicant).subscribe(
      data => {
        this.authService.getAppliant();
        this.router.navigate(['/login']);
      }
    );
  }
}
